module.exports = __webpack_public_path__ + "r-v3/img/all_eraser.bae0fcf4.svg";